var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplyVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    width: 13.859,
    height: 9.229,
    viewBox: "0 0 13.859 9.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.879,16.729H3.051A1.208,1.208,0,0,1,2,15.411V8.818A1.208,1.208,0,0,1,3.051,7.5H9.879a1.208,1.208,0,0,1,1.051,1.318v6.592A1.208,1.208,0,0,1,9.879,16.729Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,10.452v3.992l2.739,1.972a.578.578,0,0,0,.633.033.675.675,0,0,0,.325-.587V9.034a.675.675,0,0,0-.326-.587.578.578,0,0,0-.633.033Z",
    transform: "translate(-8.838 -0.333)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyVideo);
export default __webpack_public_path__ + "static/media/reply-video.383167692d7b54b2d983871afd1a7438.svg";
export { ForwardRef as ReactComponent };